<template>
	<div ng-if="overlayController" class="windowOverlay" id="heroEditor" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="659">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="Hero.ChangeAppearance" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Изменить внешность</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" @click="gameModel.heroEditorShow = false"><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="heroEditor">
							<div class="contentBox gradient double previewBox">
								<h6 class="contentBoxHeader headerWithArrowEndings glorious">
									<div class="content" translate=""><span>Герой</span></div>
								</h6>
								<div class="contentBoxBody heroImageContainer" ng-class="{noGenderSelection: !config.balancing.features.femaleHero}">
									<avatar-image avatar="editorAvatar" size="big">
										<div class="heroImage  male" ng-class="::class" rerender="rerender">
											<!-- ngIf: playerId == robberId -->
											<!-- ngIf: playerId == npcGovernorId -->
											<canvas width="350" height="350"></canvas>
										</div>
									</avatar-image>
									<div ng-if="editorAvatar.hideHelmet" class="symbol_i_medium_wrapper" tooltip="Одетый шлем сохраняет свой бонус" tooltip-translate="Hero.Face.Tooltip.Helmet">
										<i class="symbol_i_medium_flat_white"></i>
									</div>
									<div class="contentBoxBody legacyBox" ng-if="legacyItemEquipped">
										<span translate=""><span>Эта косметика больше не доступна</span></span>
									</div>
								</div>
								<div class="contentBox gradient genderBox" ng-if="config.balancing.features.femaleHero">
									<div class="contentBoxBody">
										<div class="clickableContainer genderButton clickable" :class="{'active': gender == 'male'}" clickable="changeGender(0)" @click="onChangeGender('male')" tooltip="Мужской" v-tippy="{placement: 'bottom'}" tooltip-translate="Hero.Male">
											<i class="attribute_genderMale_medium_flat_black"></i>
										</div>
										<div class="clickableContainer genderButton clickable" :class="{'active': gender == 'female'}" clickable="changeGender(1)" @click="onChangeGender('female')" content="Женский" v-tippy="{placement: 'bottom'}" tooltip-translate="Hero.Female">
											<i class="attribute_genderFemale_medium_flat_black"></i>
										</div>
									</div>
								</div>
							</div>
							<div class="contentBox gradient editHeroBox">
								<div class="contentBoxBody">
									<table class="featureSelection transparent">
										<tbody>
											<tr>
												<td>
													<a clickable="previousOption()" @click="onPreviousAttribute()" class="iconButton doubleBorder previous clickable">
														<i class="symbol_arrowFrom_tiny_flat_black"></i>
													</a>
												</td>
												<td>
													<select style="display: block; width: 100%; height: 24px;" v-model="selAttribute">
														<option v-for="attr in filteredAttributes" :key="attr.apiname" :value="attr.apiname">{{attr.name}}</option>
													</select>
													<!--
													<div class="doubleBorder dropdownContainer" dropdown="" data="editorDropdown">
														<div class="dropdownHead openDownwards closed clickable" clickable="clickDropdown()">
															<span class="selectedItem truncated">Борода</span>
															<i class="symbol_arrowDown_tiny_illu"></i>
														</div>
														<input class="dropdownInput" type="text">
													</div>
													-->
												</td>
												<td>
													<a clickable="nextOption()" @click="onNextAttribute()" class="iconButton doubleBorder next clickable">
														<i class="symbol_arrowTo_tiny_flat_black"></i>
													</a>
												</td>
											</tr>
										</tbody>
									</table>
									<div ng-if="privileges.filled" class="customizationOptions scrollable">
										<div class="scrollContentOuterWrapper active">
											<div class="scrollContent" style="overflow-y: auto;">
												<div class="scrollContentInnerWrapper" style="width: auto; display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 5px;">
													<div v-for="item in activeAttribute.items" :key="item.name">
														<div v-if="!item.locked || !item.purchasable" class="option entityBox" :class="{
															'dummy': false,
															'active': false,
															'disabled': item.locked,
															'locked': item.locked
														}" :content="item.tooltip" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-translate="Hero.Face.Option.Tooltip_halloweenChallenge" clickable="changeAttribute(selectedOption, optionItems[(n*customizationColumns)+m].index)">
															<img :src="'//iwstatic.g.bsrv.su/img/heroAvatar/'+gender+'/thumb/head/'+activeAttribute.apiname+'/'+activeAttribute.apiname+item.name+'.png'" style="display: inline;" data-cmp-info="10"/>
														</div>
														<div v-if="item.locked && item.purchasable" class="option entityBox premium" :class="{
															'disabled': item.lock
														}" :content="item.tooltip" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-translate="Hero.Face.Option.Tooltip.Purchasable_halloween" premium-feature="heroCustomization" price="1000" premium-callback-param="55" confirm-gold-usage="force" confirmation-params="{&quot;option&quot;:&quot;cosmetic&quot;,&quot;type&quot;:&quot;55&quot;}">
															<img :src="'//iwstatic.g.bsrv.su/img/heroAvatar/'+gender+'/thumb/head/'+activeAttribute.apiname+'/'+activeAttribute.apiname+item.name+'.png'" style="display: inline;" data-cmp-info="10"/>
															<div class="price" v-if="item.price > 0">
																<div class="digit"><i class="unit_candy_small_illu"></i>{{item.price}}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<button class="randomButton jsHeroEditorRandomButton clickable" clickable="selectRandomFace()" @click="onSelectRandomFace()">
									<div class="content">
										<span ng-transclude="" class="innerText">
											<span translate=""><span>Случайно</span></span>
										</span>
										<!-- ngIf: price > 0 || forceGoldUsage -->
										<!-- ngIf: price == -1 && !forceGoldUsage -->
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
							</div>
							<div class="buttonBar">
								<button clickable="save()" class="saveButton jsHeroEditorSaveButton clickable">
									<div class="content">
										<span ng-transclude="" class="innerText">
											<span translate=""><span>Сохранить</span></span>
										</span>
										<!-- ngIf: price > 0 || forceGoldUsage -->
										<!-- ngIf: price == -1 && !forceGoldUsage -->
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
								<button ng-class="{disabled: !somethingChanged()}" clickable="resetChanges()" class="resetButton cancel clickable disabled">
									<div class="content">
										<span ng-transclude="" class="innerText">
											<span translate=""><span>Сбросить изменения</span></span>
										</span>
										<!-- ngIf: price > 0 || forceGoldUsage -->
										<!-- ngIf: price == -1 && !forceGoldUsage -->
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.entityBox {
	width: 70px;
	height: 70px;
}
</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		selAttribute: null,
		gender: null,
		selAttrs: {
			beard: null,
			color: null,
			cosmetic: null,
			ear: null,
			eye: null,
			eyebrow: null,
			hair: null,
			mouth: null,
			nose: null,
		},
		
		attributes: [
			{
				apiname: 'beard',
				name: 'Борода',
				gender: ['male'],
				items: [
					{name: 'None', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'color',
				name: 'Цвет волос',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'cosmetic',
				name: 'Косметика',
				gender: ['male', 'female'],
				items: [
					{name: 'None', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '0', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '1', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '2', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '3', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '4', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '5', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '6', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '7', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '8', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '9', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '10', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash 2021"'},
					{name: '11', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '12', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '13', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '14', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '15', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '16', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '17', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '18', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '19', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '20', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '21', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '22', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '23', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '24', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '25', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '26', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '27', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash 2022"'},
					{name: '28', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '29', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '30', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '31', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '32', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '33', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '34', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '35', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '36', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '37', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в Зимнем пакете 2022'},
					{name: '38', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash 2023"'},
					{name: '39', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '40', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '41', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '42', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '43', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash"'},
					{name: '44', locked: true, purchasable: false, price: 0, tooltip: 'Разблокируйте маску, пройдя испытание для сообщества'},
					{name: '45', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '46', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '47', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '48', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '49', locked: true, purchasable: true, price: 1000, tooltip: 'Можно получить во время события "Охота на Хеллоуин"'},
					{name: '50', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в Зимнем пакете 2023'},
					{name: '52', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в сценарии "Birthday Bash 2024"'},
					{name: '53', locked: true, purchasable: false, price: 0, tooltip: 'Доступно только в Зимнем пакете 2024'},
				],
			},
			{
				apiname: 'ear',
				name: 'Уши',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'eye',
				name: 'Глаза',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '12', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'eyebrow',
				name: 'Брови',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'hair',
				name: 'Прическа',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '12', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '13', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '14', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'mouth',
				name: 'Рот',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
			{
				apiname: 'nose',
				name: 'Нос',
				gender: ['male', 'female'],
				items: [
					{name: '0', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '1', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '2', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '3', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '4', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '5', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '6', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '7', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '8', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '9', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '10', locked: false, purchasable: false, price: 0, tooltip: ''},
					{name: '11', locked: false, purchasable: false, price: 0, tooltip: ''},
				],
			},
		],
	}),
	watch: {
		gender(val, oldVal){
			if(!this.activeAttribute.gender.includes(val)){
				let ind = this.filteredAttributes.findIndex(el => el.apiname == this.activeAttribute.apiname);
				if(this.filteredAttributes[ind + 1]){
					this.selAttribute = this.filteredAttributes[ind + 1].apiname;
				} else {
					this.selAttribute = this.filteredAttributes[0].apiname;
				}
			}
		},
	},
	computed: {
		activeAttribute(){
			return this.attributes.find(el => el.apiname == this.selAttribute) || {};
		},
		filteredAttributes(){
			return this.attributes.filter(el => el.gender.includes(this.gender));
		},
	},
	methods: {
		onChangeGender(gender){
			this.gender = gender;
		},
		onPreviousAttribute(){
			let ind = this.filteredAttributes.findIndex(el => el.apiname == this.activeAttribute.apiname);
			if(this.filteredAttributes[ind - 1]){
				this.selAttribute = this.filteredAttributes[ind - 1].apiname;
			} else {
				this.selAttribute = this.filteredAttributes[this.filteredAttributes.length - 1].apiname;
			}
		},
		onNextAttribute(){
			let ind = this.filteredAttributes.findIndex(el => el.apiname == this.activeAttribute.apiname);
			if(this.filteredAttributes[ind + 1]){
				this.selAttribute = this.filteredAttributes[ind + 1].apiname;
			} else {
				this.selAttribute = this.filteredAttributes[0].apiname;
			}
		},
		onSelectRandomFace(){
			
		},
	},
	created(){
		this.selAttribute = this.attributes[0].apiname;
		this.gender = 'male';
	},
	mounted(){},
	components: {},
}
</script>